import { type MeetingListFilter } from '@littlebird/sdk';

export type MeetingsFilter = MeetingListFilter;

export const ALL_MEETINGS_FILTER: MeetingsFilter = {
  kind: 'all-meetings',
};
